import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'common/i18n/hooks';
import styles from './_chart-header.module.styl';
import { getChartTicks } from './util';
type ExperimentPageSummaryMetricsCategoryChartHeaderProps = {
  absMax: number;
};
export function ExperimentPageSummaryMetricsCategoryChartHeader(props: ExperimentPageSummaryMetricsCategoryChartHeaderProps) {
  const i18n = useTranslation();
  const percentFormatter = new Intl.NumberFormat(i18n.language, {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
  const ticks = getChartTicks(props.absMax);
  return <div className={styles.wrapper} data-sentry-component="ExperimentPageSummaryMetricsCategoryChartHeader" data-sentry-source-file="_chart-header.tsx">
      {ticks.map((_ref, i) => {
      let {
        left,
        value,
        minor,
        zero
      } = _ref;
      return <React.Fragment key={i}>
          <div className={clsx(styles.tick, {
          [styles.zero]: zero,
          [styles.minor]: minor
        })} style={{
          left
        }} />
          {value !== undefined && <div className={styles.tickLabel} style={{
          left
        }}>
              {percentFormatter.format(value)}
            </div>}
        </React.Fragment>;
    })}
    </div>;
}